import React, { useEffect, useRef } from "react";

// ASSETS

// STYLES
import {
  LayoutContainer,
  HeaderWrapper,
  ContentContainer,
  FooterWrapper,
} from "./LayoutWrapperStyled";

// LIBRARIES
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";

// MISC
import { ILayoutContext } from "./LayoutWrapperModel";
import { appRoutes } from "config/AppRoutesConfig";
import { sectionNavigation } from "config/SectionNavigationConfig";

// COMPONENTS
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import HeaderMobile from "components/HeaderMobile/HeaderMobile";
import ScrollCardsMenu from "components/ScrollMenu/ScrollCardsMenu";
// import Girdle from "components/Girdle/Girdle";

// CONFIGURATION
const LayoutWrapper = (props: ILayoutContext) => {
  const { hasHeader = true } = props;

  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const location = useLocation();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 1370 });
  const { t } = useTranslation();
  const navigation = sectionNavigation[pathname];
  const headerRef = useRef<HTMLDivElement>(null);
  const topOfPageRef = useRef<HTMLDivElement>(null);

  // STATE CONSTANTS

  const noFooterRoutes = [
    appRoutes.map,
    appRoutes.legislation,
    appRoutes.news,
    new RegExp(`^${appRoutes.map}/[^/]+$`),
  ];
  const isRouteMatch = noFooterRoutes.some((route) => {
    if (route instanceof RegExp) {
      return route.test(location.pathname);
    }
    return route === location.pathname;
  });

  // LIFE CYCLE
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    const updateOffset = () => {
      topOfPageRef.current?.style.setProperty("--navigation-offset", `${header.offsetHeight + 24}px`);
    };
    updateOffset();
    const observer = new ResizeObserver(updateOffset);
    observer.observe(header);
    return () => observer.disconnect();
  }, [pathname, hasHeader]);

  useEffect(() => {
    setTimeout(() => {
      topOfPageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 0);
  }, [pathname]);

  // EVENT HANDLERS

  const handleScrollToTop = () => {
    topOfPageRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <LayoutContainer ref={topOfPageRef}>
      {hasHeader && (
        <HeaderWrapper ref={headerRef} data-site-header $hasSectionNavigation={!!navigation}>
          {isMobile ? (
            <HeaderMobile handleScrollToTop={handleScrollToTop} hasSectionNavigation={!!navigation} />
          ) : (
            <Header handleScrollToTop={handleScrollToTop} hasSectionNavigation={!!navigation} />
          )}
          {navigation && (
            <ScrollCardsMenu key={pathname} sectionTitle={t(navigation.titleKey)}
              cards={navigation.sections.map(section => ({ id: section.id, title: t(section.titleKey) }))} />
          )}
        </HeaderWrapper>
      )}
      <ContentContainer noFooter={isRouteMatch} $hasSectionNavigation={!!navigation}>
        <Outlet />
      </ContentContainer>
      {!isRouteMatch && (
        <FooterWrapper>
          <Footer handleScrollToTop={handleScrollToTop} />
        </FooterWrapper>
      )}
        {/* <GirdleWrapper>
            <Girdle />
        </GirdleWrapper> */}
    </LayoutContainer>
  );
};

export default LayoutWrapper;
